import { useQuery } from '@tanstack/react-query';

import { getUnfinishedRoutesMutationKey } from '.';
import { routeService } from '../../../../application/RouteService';

// Hook to retrieve the number of old unfinished routes
export const useSearchUnfinishedRoutes = () => {
  const { isSuccess, refetch, data, error, isLoading } = useQuery(
    getUnfinishedRoutesMutationKey(),
    () => routeService.searchUnfinishedRoutes(),
    {
      retry: 1,
      enabled: true,
      refetchOnWindowFocus: false,
    }
  );

  return {
    error: error,
    success: isSuccess,
    isLoading: isLoading,
    data: data,
    run: refetch,
  };
};
